import React from 'react';

interface ResetZoomButtonProps {
    onClick: () => void;
    onCloseRegionCard?: () => void;
}

/**
 * ResetZoomButton - Button to reset map zoom to default bounds
 */
export const ResetZoomButton: React.FC<ResetZoomButtonProps> = ({
    onClick,
    onCloseRegionCard,
}) => {
    const handleClick = () => {
        onClick();
        onCloseRegionCard?.();
    };

    return (
        <div
            className="reset-zoom-icon bg-white d-flex justify-content-center align-items-center"
            title="Reset Zoom"
            onClick={handleClick}
        >
            <span className='material-symbols-outlined cursor-pointer icon-gray-0'>restart_alt</span>
        </div>
    );
};
